// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%) !important;
  border-radius: 24px !important;
  padding: 2.5rem 2rem !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
  text-align: center;
  border: none !important;
}

.login-card-simple {
  width: 100%;
  max-width: 420px;
  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);
  border-radius: 24px;
  padding: 2.5rem 2rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  text-align: center;
  border: none;
}

/* Logo */
.logo-container {
  margin-bottom: 1.5rem;
}

.logo-image {
  width: 144px;
  height: 144px;
  object-fit: contain;
}

/* Título do Sistema */
.system-header {
  margin-bottom: 1.5rem;
}

.system-title {
  color: #FFD700 !important;
  font-size: 2.5rem !important;
  font-weight: 700 !important;
  margin-bottom: 0.25rem !important;
  letter-spacing: 2px;
  -webkit-text-stroke: 1px #6c757d;
  text-stroke: 1px #6c757d;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.system-subtitle {
  color: #6c757d !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  margin: 0 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}



/* Formulário */
.login-form {
  margin-top: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.form-label {
  display: block;
  color: #495057 !important;
  font-size: 0.9rem;
  font-weight: 600 !important;
  margin-bottom: 0.5rem;
}

.login-input {
  border-radius: 12px !important;
  border: 2px solid #dee2e6 !important;
  background: #f8f9fa !important;
  padding: 0.75rem 1rem !important;
  font-size: 1rem !important;
}

.login-input:focus,
.login-input:hover {
  border-color: #FFD700 !important;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2) !important;
}

.login-input .ant-input {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #495057 !important;
  font-weight: 500;
}

/* Garantir que o texto digitado seja cinza */
.login-input input {
  color: #495057 !important;
  font-weight: 500 !important;
}

.login-input input::placeholder {
  color: #495057 !important;
  opacity: 0.8 !important;
}

/* Estilos para inputs simples do SimpleLogin */
.simple-input {
  width: 100%;
  border-radius: 12px;
  border: 2px solid #dee2e6;
  background: #f8f9fa;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  color: #495057 !important;
  font-weight: 500;
  transition: all 0.3s ease;
}

.simple-input:focus {
  outline: none;
  border-color: #FFD700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
  color: #495057 !important;
}

.simple-input::placeholder {
  color: #343a40 !important;
  opacity: 0.9 !important;
}

.input-icon {
  color: #6c757d !important;
}

.login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  height: 48px !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  margin-top: 1rem !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
  transition: all 0.3s ease !important;
}

.login-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6) !important;
}

.simple-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #dee2e6;
  border-radius: 12px;
  background: #f8f9fa;
  font-size: 1rem;
  color: #495057;
  font-weight: 500;
  transition: all 0.3s ease;
}

.simple-input:focus {
  outline: none;
  border-color: #FFD700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.simple-button {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(45, 52, 54, 0.4);
}

.simple-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(45, 52, 54, 0.6);
}

.simple-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Responsividade */
@media (max-width: 480px) {
  .login-container {
    padding: 1rem;
  }
  
  .login-card,
  .login-card-simple {
    padding: 2rem 1.5rem !important;
  }
  
  .system-title {
    font-size: 2rem !important;
  }
  
  .logo-image {
    width: 115px;
    height: 115px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qFAAqF;EACrF,8BAA8B;EAC9B,+BAA+B;EAC/B,qDAAqD;EACrD,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0EAA0E;EAC1E,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,8JAA8J;AAChK;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,8JAA8J;AAChK;;;;AAIA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;EAEE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,0DAA0D;EAC1D,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".login-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 2rem;\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);\n}\n\n.login-card {\n  width: 100%;\n  max-width: 420px;\n  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%) !important;\n  border-radius: 24px !important;\n  padding: 2.5rem 2rem !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;\n  text-align: center;\n  border: none !important;\n}\n\n.login-card-simple {\n  width: 100%;\n  max-width: 420px;\n  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 50%, #dee2e6 100%);\n  border-radius: 24px;\n  padding: 2.5rem 2rem;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: none;\n}\n\n/* Logo */\n.logo-container {\n  margin-bottom: 1.5rem;\n}\n\n.logo-image {\n  width: 144px;\n  height: 144px;\n  object-fit: contain;\n}\n\n/* Título do Sistema */\n.system-header {\n  margin-bottom: 1.5rem;\n}\n\n.system-title {\n  color: #FFD700 !important;\n  font-size: 2.5rem !important;\n  font-weight: 700 !important;\n  margin-bottom: 0.25rem !important;\n  letter-spacing: 2px;\n  -webkit-text-stroke: 1px #6c757d;\n  text-stroke: 1px #6c757d;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.system-subtitle {\n  color: #6c757d !important;\n  font-size: 0.9rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 1px;\n  margin: 0 !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n\n\n/* Formulário */\n.login-form {\n  margin-top: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n  text-align: left;\n}\n\n.form-label {\n  display: block;\n  color: #495057 !important;\n  font-size: 0.9rem;\n  font-weight: 600 !important;\n  margin-bottom: 0.5rem;\n}\n\n.login-input {\n  border-radius: 12px !important;\n  border: 2px solid #dee2e6 !important;\n  background: #f8f9fa !important;\n  padding: 0.75rem 1rem !important;\n  font-size: 1rem !important;\n}\n\n.login-input:focus,\n.login-input:hover {\n  border-color: #FFD700 !important;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2) !important;\n}\n\n.login-input .ant-input {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: #495057 !important;\n  font-weight: 500;\n}\n\n/* Garantir que o texto digitado seja cinza */\n.login-input input {\n  color: #495057 !important;\n  font-weight: 500 !important;\n}\n\n.login-input input::placeholder {\n  color: #495057 !important;\n  opacity: 0.8 !important;\n}\n\n/* Estilos para inputs simples do SimpleLogin */\n.simple-input {\n  width: 100%;\n  border-radius: 12px;\n  border: 2px solid #dee2e6;\n  background: #f8f9fa;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  color: #495057 !important;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.simple-input:focus {\n  outline: none;\n  border-color: #FFD700;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\n  color: #495057 !important;\n}\n\n.simple-input::placeholder {\n  color: #343a40 !important;\n  opacity: 0.9 !important;\n}\n\n.input-icon {\n  color: #6c757d !important;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  border: none !important;\n  border-radius: 12px !important;\n  height: 48px !important;\n  font-size: 1.1rem !important;\n  font-weight: 600 !important;\n  margin-top: 1rem !important;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;\n  transition: all 0.3s ease !important;\n}\n\n.login-button:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6) !important;\n}\n\n.simple-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid #dee2e6;\n  border-radius: 12px;\n  background: #f8f9fa;\n  font-size: 1rem;\n  color: #495057;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.simple-input:focus {\n  outline: none;\n  border-color: #FFD700;\n  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\n}\n\n.simple-button {\n  width: 100%;\n  height: 48px;\n  background: linear-gradient(135deg, #2d3436 0%, #636e72 50%, #2d3436 100%);\n  border: none;\n  border-radius: 12px;\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-top: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(45, 52, 54, 0.4);\n}\n\n.simple-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(45, 52, 54, 0.6);\n}\n\n.simple-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsividade */\n@media (max-width: 480px) {\n  .login-container {\n    padding: 1rem;\n  }\n  \n  .login-card,\n  .login-card-simple {\n    padding: 2rem 1.5rem !important;\n  }\n  \n  .system-title {\n    font-size: 2rem !important;\n  }\n  \n  .logo-image {\n    width: 115px;\n    height: 115px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
